// @flow

import { type Merchant } from '@tectonics/prs/merchant/types';

export function getLookAndFeel(merchant: Merchant): string {
  return merchant['look_and_feel'];
}
